import {
  AmountType,
  CapacityCategory,
  CostType,
} from 'src/apis/monolith/types';
import { FlowDirection } from 'src/components/data-display/direction';
import { PeriodTypeValue } from 'src/pages/reporting/auctions/components/period-type';
import { RawProductState } from 'src/pages/reporting/products/types';
import * as pp from 'src/utils/page-params';

export function useUploadsParams() {
  return pp.usePageParams(
    pp
      .configure()
      .add(pp.start('start'))
      .add(pp.number('pageSize').default(10))
      .add(
        pp
          .param('amountSetting')
          .default<AmountType>('KILO')
          .filter({ label: 'Capacity' })
      )
      .add(
        pp
          .param('costSetting')
          .default<CostType>('SUBUNIT')
          .filter({ label: 'Currency' })
      )
      .add(pp.param('sortColumn').default('changedAt'))
      .add(pp.boolean('sortAscending'))

      .add(pp.param('changedAtFrom').filter({ label: 'Time of Change' }))
      .add(pp.param('changedAtTo').filter({ label: 'Time of Change' }))
      .add(pp.param('offerId').filter({ label: 'Offer ID' }))
      .add(pp.list('networkPointName').filter({ label: 'Network Point' }))
      .add(
        pp
          .list('direction')
          .cast<FlowDirection>()
          .filter({ label: 'Direction' })
      )
      .add(
        pp
          .list('capacityCategory')
          .cast<CapacityCategory>()
          .filter({ label: 'Category' })
      )
      .add(
        pp
          .list('periodType')
          .cast<PeriodTypeValue>()
          .filter({ label: 'Product' })
      )
      .add(pp.param('runtimeFrom').filter({ label: 'Runtime' }))
      .add(pp.param('runtimeTo').filter({ label: 'Runtime' }))
      .add(
        pp.param('regulatedTariff-min').filter({ label: 'Regulated Tariff' })
      )
      .add(
        pp.param('regulatedTariff-max').filter({ label: 'Regulated Tariff' })
      )
      .add(pp.param('amount-min').filter({ label: 'Amount' }))
      .add(pp.param('amount-max').filter({ label: 'Amount' }))
      .add(
        pp
          .list('rawProductState')
          .optionalDefault<RawProductState[]>(['UPLOADED', 'SUBMITTED'])
          .filter({ label: 'Status' })
      )
  );
}

export type PageParams = ReturnType<typeof useUploadsParams>;

export type UploadsParams = PageParams['value'];
